import { TApplicationState } from 'shared/types/redux';

export const getModalVisible = (state: TApplicationState): boolean => {
  return state.modal.visible;
};
